import { ClosedSangjoProps } from "@/types/sangjoType";
import { VStack } from "goi_common";

const ParlorClosedFuneralInformation = () => {
  return (
    <VStack as="section">
      <p className="body_14_m">
        (납입 금액에 따라 다르겠지만) 납입 금액의 50%에 해당하는 피해보상금을 보전받으신 후 후불제
        상조를 이용하시는 게 더 합리적일 수 있습니다. 후불제 상조를 포함한 전체 장례 비용 견적을
        확인하시고 합리적으로 장례를 준비하세요.
      </p>
    </VStack>
  );
};

export default ParlorClosedFuneralInformation;
